// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-role-containers {
  overflow: hidden;
  height: 100vh;
}
.create-role-containers .create-role-main {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.create-role-containers .create-role {
  width: 100%;
  background: #ffffff;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
}
.create-role-containers .create-role::-webkit-scrollbar {
  width: 0px;
}
.create-role-containers .create-role::-webkit-scrollbar-thumb {
  background: transparent;
}
.create-role-containers .create-role {
  scrollbar-width: none;
}
.create-role-containers .create-role-section {
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  padding: 30px;
  border-radius: 8px;
  width: 98%;
  margin: auto;
  margin-bottom: 20px;
}
.create-role-containers .header-navigation {
  background: #c0c8da;
  height: 2.4rem;
  border: 1px solid #c0c8da;
  width: 99.5%;
}
.create-role-containers .create-role-text {
  font-family: "Nunito";
  font-size: 12px;
  font-weight: 500;
  color: #2D2D2D;
  padding: 0.5rem;
}
.create-role-containers .create-role-heading {
  width: 97%;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.create-role-containers .role-name-state {
  display: flex;
  align-items: center;
  gap: 50px;
  width: 98%;
  margin: auto;
}
.create-role-containers .role-name-state .role-label {
  position: absolute;
  top: -10px;
  left: 15px;
}
.create-role-containers .role-state {
  margin-top: 20px;
}
.create-role-containers .role-name,
.create-role-containers .role-state {
  width: 40%;
  display: flex;
  align-items: center;
  position: relative;
}
.create-role-containers .role-name h6,
.create-role-containers .role-state h6 {
  margin-bottom: 10px;
  font-weight: bold;
  width: 30%;
  white-space: nowrap;
}
.create-role-containers .role-name input,
.create-role-containers .role-name select,
.create-role-containers .role-state input,
.create-role-containers .role-state select {
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100% !important;
  height: 50.4px !important;
}
.create-role-containers .reports-to {
  width: 40%;
  display: flex;
  align-items: center;
  position: relative;
}
.create-role-containers .reports-to h6 {
  margin-bottom: 10px;
  font-weight: bold;
  width: 27%;
  white-space: nowrap;
}
.create-role-containers .reports-to select {
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100% !important;
  height: 50.4px !important;
}
.create-role-containers .cms-mobile-permission-checkbox {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}
.create-role-containers .part_label {
  top: -7px !important;
  left: 15px !important;
}
.create-role-containers .multiselect_part {
  margin-left: 0px !important;
  width: 100% !important;
}
.create-role-containers .multiselect_part fieldset {
  border: 1px solid #a3aec4;
  border-radius: 6px;
}
.create-role-containers .multipleSelect_part {
  height: 54.4px;
  width: 100% !important;
}
.create-role-containers .multiselect_input {
  min-width: 80% !important;
}
.create-role-containers .permissions-container {
  margin-left: 30px;
}
.create-role-containers .permissions {
  margin-top: 30px;
}
.create-role-containers .permission-button {
  width: 97%;
  margin: auto;
  display: flex;
  align-items: center;
  gap: 40px;
  margin-top: 30px;
  margin-bottom: 10px;
}
.create-role-containers .permissions input {
  position: inherit !important;
  height: 15px;
  width: 15px !important;
}
.create-role-containers .permission-radio-button {
  display: flex;
  align-items: center;
  gap: 6px;
}
.create-role-containers .permissions .permission {
  position: inherit;
  font-size: 16px;
  color: black;
  font-weight: bolder;
}
.create-role-containers .permissions h5 {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.create-role-containers .permission-list {
  margin-left: 20px;
}
.create-role-containers .permission-list .permission-item {
  margin-bottom: 5px;
}
.create-role-containers .permission-category {
  margin-bottom: 20px;
}
.create-role-containers .permission-category .all-subcategories {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-left: 20px;
}
.create-role-containers .permission-category .permission-subcategory {
  margin-left: 20px;
}
.create-role-containers .permission-category .permission-subcategory .subcategory-permissions {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.create-role-containers .permission-category .permission-subcategory .subcategory-permissions .permission-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.create-role-containers .permission-category .permission-subcategory .subcategory-permissions .permission-item input {
  width: 20px !important;
  height: 30px;
}
.create-role-containers .permission-category .permission-item,
.create-role-containers .permission-category .subcategory-header,
.create-role-containers .permission-category .category-header {
  display: flex;
  gap: 10px;
  align-items: center;
}
.create-role-containers .permission-category .subcategory-header {
  font-weight: bold;
  margin-bottom: 5px;
}
.create-role-containers .permission-category .subcategory-header input {
  width: 20px !important;
  height: 20px !important;
}
.create-role-containers .permission-category p {
  margin-bottom: 0 !important;
  white-space: nowrap;
}
.create-role-containers .report-dropdown {
  margin-top: 10px;
}
.create-role-containers .report-checkbox {
  margin-top: 18px;
}
.create-role-containers .cancel-submit-btn {
  display: flex;
  gap: 15px;
  margin-top: 60px;
}
.create-role-containers .cancel-submit-btn .cancel-btn {
  border: 1px solid #0C3688;
  width: 128px;
  height: 32px;
  color: #0C3688;
  background-color: white;
  border-radius: 6.4px;
}
.create-role-containers .cancel-submit-btn .submit-btn {
  width: 128px;
  height: 32px;
  border-radius: 6.4px;
  background-color: #0C3688;
  color: white;
}
.create-role-containers .cancel-submit-btn .submit-btn:disabled {
  background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);
}
.create-role-containers .cancel-submit-btn .loader-btn {
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  animation: spin 1s linear infinite;
  display: inline-block;
  vertical-align: middle;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 768px) {
  .create-role-main {
    display: flex;
    flex-direction: column;
  }
  .create-role-section {
    padding: 10px !important;
  }
  .create-role {
    width: 100% !important;
  }
  .role-name-state {
    flex-direction: column;
    gap: 20px !important;
  }
  .role-name,
  .reports-to,
  .role-state {
    width: 100% !important;
  }
  .multipleSelect_part {
    width: 100% !important;
  }
  .create-role-containers .role-name h6, .role-state h6, .reports-to h6 {
    position: absolute;
    top: -7px;
    z-index: 101;
    font-weight: 400 !important;
    background: white;
    left: 16px;
    font-size: 12px;
    width: auto !important;
  }
  .create-role-containers .role-name, .role-state, .reports-to {
    position: relative;
  }
  .create-role-containers .multipleSelect_part {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/createRole/CreateRole.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACR;AAEI;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;AAAR;AAEQ;EACI,UAAA;AAAZ;AAGQ;EACI,uBAAA;AADZ;AAIQ;EACI,qBAAA;AAFZ;AAMI;EACI,2CAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AAJR;AAOI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,YAAA;AALR;AAQI;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AANR;AASI;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AAPR;AAUI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AARR;AAUQ;EACI,kBAAA;EACA,UAAA;EACA,UAAA;AARZ;AAYI;EACI,gBAAA;AAVR;AAaI;;EAEI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAXR;AAaQ;;EACI,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AAVZ;AAaQ;;;;EAEI,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AATZ;AAaI;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAXR;AAaQ;EACI,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AAXZ;AAcQ;EACI,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;AAZZ;AAgBI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AAdR;AAiBI;EACI,oBAAA;EACA,qBAAA;AAfR;AAkBI;EACI,2BAAA;EACA,sBAAA;AAhBR;AAmBI;EACI,yBAAA;EACA,kBAAA;AAjBR;AAoBI;EACI,cAAA;EACA,sBAAA;AAlBR;AAqBI;EACI,yBAAA;AAnBR;AAsBI;EACI,iBAAA;AApBR;AAuBI;EACI,gBAAA;AArBR;AAwBI;EACI,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAtBR;AAyBI;EACI,4BAAA;EACA,YAAA;EACA,sBAAA;AAvBR;AA0BI;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAxBR;AA2BI;EACI,iBAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;AAzBR;AA4BI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AA1BR;AA6BI;EACI,iBAAA;AA3BR;AA8BI;EACI,kBAAA;AA5BR;AA+BI;EACI,mBAAA;AA7BR;AA+BQ;EACI,aAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AA7BZ;AAgCQ;EACI,iBAAA;AA9BZ;AAkCY;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AAhChB;AAkCgB;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAhCpB;AAkCoB;EACI,sBAAA;EACA,YAAA;AAhCxB;AAsCQ;;;EAGI,aAAA;EACA,SAAA;EACA,mBAAA;AApCZ;AAuCQ;EACI,iBAAA;EACA,kBAAA;AArCZ;AAuCY;EACI,sBAAA;EACA,uBAAA;AArChB;AAyCQ;EACI,2BAAA;EACA,mBAAA;AAvCZ;AA2CI;EACI,gBAAA;AAzCR;AA4CI;EACI,gBAAA;AA1CR;AA6CI;EACI,aAAA;EACA,SAAA;EACA,gBAAA;AA3CR;AA6CQ;EACI,yBAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;EACA,oBAAA;AA3CZ;AA8CQ;EACI,YAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,YAAA;AA5CZ;AA+CQ;EACI,mEAAA;AA7CZ;AAgDQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,qBAAA;EACA,sBAAA;AA9CZ;AAiDQ;EACI;IACI,uBAAA;EA/Cd;EAkDU;IACI,yBAAA;EAhDd;AACF;;AAsDA;EACI;IACI,aAAA;IACA,sBAAA;EAnDN;EAsDE;IACI,wBAAA;EApDN;EAuDE;IACI,sBAAA;EArDN;EAwDE;IACI,sBAAA;IACA,oBAAA;EAtDN;EAyDE;;;IAGI,sBAAA;EAvDN;EA0DE;IACI,sBAAA;EAxDN;EA2DE;IACI,kBAAA;IACA,SAAA;IACA,YAAA;IACA,2BAAA;IACA,iBAAA;IACA,UAAA;IACA,eAAA;IACA,sBAAA;EAzDN;EA4DE;IACI,kBAAA;EA1DN;EA6DE;IACI,sBAAA;EA3DN;AACF","sourcesContent":[".create-role-containers {\n    overflow: hidden;\n    height: 100vh;\n\n    .create-role-main {\n        width: 100%;\n        display: flex;\n        overflow: hidden;\n    }\n\n    .create-role {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: auto;\n        overflow-x: hidden;\n        height: calc(100vh - 66px);\n\n        &::-webkit-scrollbar {\n            width: 0px;\n        }\n\n        &::-webkit-scrollbar-thumb {\n            background: transparent;\n        }\n\n        & {\n            scrollbar-width: none;\n        }\n    }\n\n    .create-role-section {\n        box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;\n        padding: 30px;\n        border-radius: 8px;\n        width: 98%;\n        margin: auto;\n        margin-bottom: 20px;\n    }\n\n    .header-navigation {\n        background: #c0c8da;\n        height: 2.4rem;\n        border: 1px solid #c0c8da;\n        width: 99.5%;\n    }\n\n    .create-role-text {\n        font-family: \"Nunito\";\n        font-size: 12px;\n        font-weight: 500;\n        color: #2D2D2D;\n        padding: 0.5rem;\n    }\n\n    .create-role-heading {\n        width: 97%;\n        margin: auto;\n        margin-top: 20px;\n        margin-bottom: 20px;\n    }\n\n    .role-name-state {\n        display: flex;\n        align-items: center;\n        gap: 50px;\n        width: 98%;\n        margin: auto;\n\n        .role-label{\n            position: absolute;\n            top: -10px;\n            left: 15px;\n        }\n    }\n\n    .role-state {\n        margin-top: 20px;\n    }\n\n    .role-name,\n    .role-state {\n        width: 40%;\n        display: flex;\n        align-items: center;\n        position: relative;\n\n        h6 {\n            margin-bottom: 10px;\n            font-weight: bold;\n            width: 30%;\n            white-space: nowrap;\n        }\n\n        input,\n        select {\n            padding: 8px;\n            font-size: 16px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n            width: 100% !important;\n            height: 50.4px !important;\n        }\n    }\n\n    .reports-to {\n        width: 40%;\n        display: flex;\n        align-items: center;\n        position: relative;\n\n        h6 {\n            margin-bottom: 10px;\n            font-weight: bold;\n            width: 27%;\n            white-space: nowrap;\n        }\n\n        select {\n            padding: 8px;\n            font-size: 16px;\n            border: 1px solid #ccc;\n            border-radius: 4px;\n            width: 100% !important;\n            height: 50.4px !important;\n        }\n    }\n\n    .cms-mobile-permission-checkbox {\n        display: flex;\n        gap: 10px;\n        margin-bottom: 20px;\n    }\n\n    .part_label {\n        top: -7px !important;\n        left: 15px !important;\n    }\n\n    .multiselect_part {\n        margin-left: 0px !important;\n        width: 100% !important;\n    }\n\n    .multiselect_part fieldset {\n        border: 1px solid #a3aec4;\n        border-radius: 6px;\n    }\n\n    .multipleSelect_part {\n        height: 54.4px;\n        width: 100% !important;\n    }\n\n    .multiselect_input {\n        min-width: 80% !important;\n    }\n\n    .permissions-container {\n        margin-left: 30px;\n    }\n\n    .permissions {\n        margin-top: 30px;\n    }\n\n    .permission-button {\n        width: 97%;\n        margin: auto;\n        display: flex;\n        align-items: center;\n        gap: 40px;\n        margin-top: 30px;\n        margin-bottom: 10px;\n    }\n\n    .permissions input {\n        position: inherit !important;\n        height: 15px;\n        width: 15px !important;\n    }\n\n    .permission-radio-button {\n        display: flex;\n        align-items: center;\n        gap: 6px;\n    }\n\n    .permissions .permission {\n        position: inherit;\n        font-size: 16px;\n        color: black;\n        font-weight: bolder;\n    }\n\n    .permissions h5 {\n        display: flex;\n        align-items: center;\n        margin-bottom: 5px;\n    }\n\n    .permission-list {\n        margin-left: 20px;\n    }\n\n    .permission-list .permission-item {\n        margin-bottom: 5px;\n    }\n\n    .permission-category {\n        margin-bottom: 20px;\n\n        .all-subcategories {\n            display: flex;\n            gap: 20px;\n            flex-wrap: wrap;\n            margin-left: 20px;\n        }\n\n        .permission-subcategory {\n            margin-left: 20px;\n\n\n\n            .subcategory-permissions {\n                margin-left: 20px;\n                display: flex;\n                flex-direction: column;\n                align-items: flex-start;\n\n                .permission-item {\n                    display: flex;\n                    align-items: center;\n                    margin-bottom: 5px;\n\n                    input {\n                        width: 20px !important;\n                        height: 30px;\n                    }\n                }\n            }\n        }\n\n        .permission-item,\n        .subcategory-header,\n        .category-header {\n            display: flex;\n            gap: 10px;\n            align-items: center;\n        }\n\n        .subcategory-header {\n            font-weight: bold;\n            margin-bottom: 5px;\n\n            input {\n                width: 20px !important;\n                height: 20px !important;\n            }\n        }\n\n        p {\n            margin-bottom: 0 !important;\n            white-space: nowrap;\n        }\n    }\n\n    .report-dropdown {\n        margin-top: 10px;\n    }\n\n    .report-checkbox {\n        margin-top: 18px;\n    }\n\n    .cancel-submit-btn {\n        display: flex;\n        gap: 15px;\n        margin-top: 60px;\n\n        .cancel-btn {\n            border: 1px solid #0C3688;\n            width: 128px;\n            height: 32px;\n            color: #0C3688;\n            background-color: white;\n            border-radius: 6.4px;\n        }\n\n        .submit-btn {\n            width: 128px;\n            height: 32px;\n            border-radius: 6.4px;\n            background-color: #0C3688;\n            color: white;\n        }\n\n        .submit-btn:disabled {\n            background: linear-gradient(277.62deg, #2b3955 10%, #6994ec 84.88%);\n        }\n\n        .loader-btn {\n            border: 3px solid #f3f3f3;\n            border-top: 3px solid #3498db;\n            border-radius: 50%;\n            width: 18px;\n            height: 18px;\n            animation: spin 1s linear infinite;\n            display: inline-block;\n            vertical-align: middle;\n        }\n\n        @keyframes spin {\n            0% {\n                transform: rotate(0deg);\n            }\n\n            100% {\n                transform: rotate(360deg);\n            }\n        }\n    }\n\n}\n\n@media screen and (max-width:768px) {\n    .create-role-main {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .create-role-section {\n        padding: 10px !important;\n    }\n\n    .create-role {\n        width: 100% !important;\n    }\n\n    .role-name-state {\n        flex-direction: column;\n        gap: 20px !important;\n    }\n\n    .role-name,\n    .reports-to,\n    .role-state {\n        width: 100% !important;\n    }\n\n    .multipleSelect_part {\n        width: 100% !important;\n    }\n\n    .create-role-containers .role-name h6, .role-state h6, .reports-to h6  {\n        position: absolute;\n        top: -7px;\n        z-index: 101;\n        font-weight: 400 !important;\n        background: white;\n        left: 16px;\n        font-size: 12px;\n        width: auto !important;\n    }\n\n    .create-role-containers .role-name, .role-state, .reports-to {\n        position: relative;\n    }\n\n    .create-role-containers .multipleSelect_part {\n        width: 100% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
